



































/** @format */

import { Component, Vue, Prop } from 'vue-property-decorator';
import EchartPie from './echart-pie.vue';
@Component({
  components: { EchartPie }
})
export default class CountCard extends Vue {
  @Prop()
  title!: string;

  @Prop()
  tip: string;

  // 展示数据
  @Prop()
  count: string;

  // 字体颜色, 支持primary、success、warning、error、gray和色值（#xxxxxx）
  @Prop()
  countColor: string;

  @Prop()
  icon: string;

  @Prop()
  echart: any;

  get hasCount() {
    return !(this.count === '' || this.count === null || this.count === undefined);
  }

  get countColorClass() {
    return /^#/.test(this.countColor) ? '' : `${this.countColor}-color`;
  }

  get countColorValue() {
    return /^#/.test(this.countColor) ? this.countColor : '';
  }
}
